import { UseCarouselReturn } from '@hooks/useCarousel';
import * as React from 'react';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';

export type ConnectedProps = {
  children: (carousel: UseCarouselReturn) => React.ReactElement;
};

const Connected: React.FC<ConnectedProps> = ({ children }) => {
  const carousel = useCarouselContext();
  return children(carousel);
};

export default Connected;
